// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2PAxm","header":"MessagesList_header__3oSUK","chat":"MessagesList_chat___FyIc"};